var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"container"}},[_c('div',{attrs:{"id":"body"}},[(_vm.page === 'group1' || _vm.page === '')?[_c('BaseShare')]:_vm._e(),(_vm.page === 'group2')?[_c('AutoFeed')]:_vm._e(),(_vm.page === 'group3')?[_c('AutoSide')]:_vm._e(),(_vm.page === 'group4')?[_c('ManualFeed')]:_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }